import { render, staticRenderFns } from "./image-box.vue?vue&type=template&id=75a004de&scoped=true"
import script from "./image-box.vue?vue&type=script&lang=js"
export * from "./image-box.vue?vue&type=script&lang=js"
import style0 from "./image-box.vue?vue&type=style&index=0&id=75a004de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a004de",
  null
  
)

export default component.exports